import {
  IAddressV2,
  IPickupPoint,
  IShippingMethod,
  IPositionInMap,
} from '@monofront/types';
import { ApolloError, useLazyQuery } from '@apollo/client';
import { GET_DROP_OFF_POINTS } from '../../queries';

const limit = 20;

interface IFetchPickupListReturn {
  fetchPickupList: (
    shippingMethods: IShippingMethod[],
    shippingAddress: IAddressV2,
    homePosition?: IPositionInMap,
  ) => void;
  isListLoading: boolean;
  pickupList: IPickupPoint[];
  error?: ApolloError;
}

const useFetchPickupList = (): IFetchPickupListReturn => {
  const [getPickupList, { data, loading, error }] = useLazyQuery<{
    getDropOffPoints: IPickupPoint[];
  }>(GET_DROP_OFF_POINTS, {
    ssr: false,
  });

  const fetchPickupList = (shippingMethods, shippingAddress, homePosition) => {
    getPickupList({
      variables: {
        city: shippingAddress.city,
        zip: shippingAddress.postcode,
        country: shippingAddress.countryCode,
        limit,
        couriers: shippingMethods.map(({ tmsCode }) => tmsCode),
        lat: homePosition.latitude,
        lng: homePosition.longitude,
      },
    });
  };

  return {
    fetchPickupList,
    isListLoading: loading,
    pickupList: data?.getDropOffPoints || [],
    error,
  };
};

export default useFetchPickupList;
